export default __webpack_public_path__ + "static/media/litigation.4ad4efac.jpg";